angular.module("Main").controller("OnlineSalesController",
    ["$scope", "$uibModal", "$translate", "$stateParams", "$location", "$state", "$window", "tmhDynamicLocale", "$localStorage", "NODEBACKEND", "LANGUAGES", "BookingService",
        function ($scope, $uibModal, $translate, $stateParams, $location, $state, $window, tmhDynamicLocale, $localStorage, NODEBACKEND, LANGUAGES, BookingService) {

            var vm = this;

            vm.selectedMandantNr = _.parseInt($stateParams.club);
            vm.uuid = $stateParams.id;
            if (vm.uuid === 'tt') {
                vm.angebot = true;
            } else {
                vm.angebot = false;
            }
            vm.idNotFound = false;
            vm.OSMInactiv = false;
            vm.isInFuture = false;
            vm.isInPast = false;
            vm.noMatched = false;
            vm.showFormular = true;
            vm.memberSelected = false;

            let cycleUnits = BookingService.getCycleUnits();

            vm.$onInit = async function () {
                console.log("Init called");
                if (vm.selectedMandantNr && (vm.uuid === 'false' || vm.uuid === false || !vm.uuid || typeof vm.uuid === 'undefined') && vm.uuid !== 'tt') {
                    BookingService.loadMembershipsOnlineSales(vm.selectedMandantNr).then(function (data) {
                        if (data.length === 0 || !data || _.isUndefined(data)) {
                            vm.noMatched = true;
                        } else {
                            vm.noMatched = false;
                            if (data.LinkIdNotFound === true) {
                                vm.idNotFound = true;
                            } else if (data.IsInactiv === true) {
                                vm.OSMInactiv = true;
                                vm.isInFuture = data.IsInFuture;
                                vm.isInPast = data.IsInPast;
                                if (data.IsInFuture === true) {
                                    vm.futureDate = data.FutureDate;
                                }
                            } else {
                                vm.membershipsOptions = data;
                            }
                        }
                    }).catch(function () {
                        vm.noMatched = true;
                        vm.membershipsOptions = []; // TODO: evtl. Fehleranzeige
                    })
                } else {
                    if (vm.uuid !== 'false' && vm.uuid !== 'tt') {
                        BookingService.loadMembershipsOnlineSalesLinkConfig(vm.selectedMandantNr, vm.uuid).then(function (data) {
                            if (data.length === 0 || !data || _.isUndefined(data)) {
                                vm.noMatched = true;
                            } else {
                                if (data.LinkIdNotFound === true) {
                                    vm.idNotFound = true;
                                } else if (data.IsInactiv === true) {
                                    vm.OSMInactiv = true;
                                    vm.isInFuture = data.IsInFuture;
                                    vm.isInPast = data.IsInPast;
                                    if (data.IsInFuture === true) {
                                        vm.futureDate = data.FutureDate;
                                    }
                                }
                            }
                        }).catch(function () {
                            vm.noMatched = true;
                            vm.membershipsOptions = []; // TODO: evtl. Fehleranzeige
                        })
                    }
                }
                loadOnlineSalesFarbenConfiguration();
                loadLayoutConfiguration();
                getMandants();
            };

            function getMandants() {
                BookingService.getMandants().then(function (data) {
                    vm.clubsmandants = data;
                    vm.tenantIds = _.map(data, 'MandantNr')
                }).then(function () {
                    BookingService.getMandantsImages().then(function (data) {
                        vm.imagesClubs = data;
                        _.forEach(vm.clubsmandants, function (m) {
                            m.Image = _.find(vm.imagesClubs, {'Mandant_Nr': m.MandantNr});
                        });
                    })
                }).then(function () {
                    BookingService.checkMandantOnline().then(function (data) {
                        vm.mandantsOnline = data;

                        _.forEach(vm.clubsmandants, function (m) {
                            if (_.filter(vm.mandantsOnline, {MandantNr: m.MandantNr}).length > 0) {
                                let foundSortierung = _.filter(vm.mandantsOnline, {
                                    MandantNr: m.MandantNr,
                                })[0].Sortierung;
                                m.Sortierung = foundSortierung;
                            }
                        });
                        vm.clubsmandants = _.sortBy(vm.clubsmandants, 'Sortierung');
                        vm.allClubs = [];
                        if (vm.clubsmandants.length < vm.limitLengthClubs) {
                            vm.limitLengthClubs = vm.clubsmandants.length
                        }
                        vm.chunkedClub = _.chunk(vm.clubsmandants, vm.limitLengthClubs);
                        vm.lengthChunkedClubs = (vm.chunkedClub).length;
                        if ($window.innerWidth >= 700) {
                            for (let i = 0; i < vm.limitLengthClubs; ++i) {
                                vm.allClubs[i] = vm.clubsmandants[i];
                            }
                        } else {
                            vm.allClubs = vm.clubsmandants;
                        }
                    });
                }).then(function () {
                    BookingService.getMandantNames().then(function (data) {
                        var mandantsNames = data;
                        _.forEach(vm.clubsmandants, function (m) {
                            if (_.filter(mandantsNames, {'MandantNr': m.MandantNr})) {
                                let foundName = (_.filter(mandantsNames, {'MandantNr': m.MandantNr}))[0].MandantOnlineBezeichnung;
                                if (foundName) {
                                    m.MandantOnlineBezeichnung = foundName;
                                }
                                if ($stateParams.club) {
                                    if (m.MandantNr === vm.selectedMandantNr) {
                                        vm.selectedMandant = m;
                                        vm.selectedMandant.MandantOnlineBezeichnung = foundName
                                    }
                                }
                            }
                        })
                    })
                }).then(function () {
                    getInfoForStep1();
                })
            }

            function checkMandantOnline() {
                BookingService.checkMandantOnline().then(function (data) {
                    vm.mandantsOnline = data;
                });
            }

            vm.begin = 0;
            vm.beginClub = 0;
            vm.languageList = LANGUAGES;

            if (_.isNil(vm.currentLanguage)) {
                vm.currentLanguage = getLocalStorageLanguage();
                tmhDynamicLocale.set(vm.currentLanguage.lang);
                $translate.use(vm.currentLanguage.lang);
            }

            function getLocalStorageLanguage() {
                if (_.isNil($localStorage.currentLanguage))
                    $localStorage.currentLanguage = _.first(LANGUAGES);

                return $localStorage.currentLanguage;
            }

            var xxlarge = 2500;
            var xlarge = 2100;
            var large = 1700;
            var medium = 1300;
            var small = 900;
            var xsmall = 700;


            if ($window.innerWidth >= xxlarge) {
                vm.limitLengthClubs = 7;
                vm.limitLengthZT = 7;
                vm.limitLengthZL = 7;
            } else if ($window.innerWidth >= xlarge) {
                vm.limitLengthClubs = 6;
                vm.limitLengthZT = 6;
                vm.limitLengthZL = 6;
            } else if ($window.innerWidth >= large) {
                vm.limitLengthClubs = 5;
                vm.limitLengthZT = 5;
                vm.limitLengthZL = 5;
            } else if ($window.innerWidth >= medium) {
                vm.limitLengthClubs = 4;
                vm.limitLengthZT = 4;
                vm.limitLengthZL = 4;
            } else if ($window.innerWidth >= small) {
                vm.limitLengthClubs = 3;
                vm.limitLengthZT = 3;
                vm.limitLengthZL = 3;
            } else if ($window.innerWidth >= xsmall) {
                vm.limitLengthClubs = 2;
                vm.limitLengthZT = 2;
                vm.limitLengthZL = 2;
            } else {
                vm.limitLengthClubs = 20;
                vm.limitLengthZT = 20;
                vm.limitLengthZL = 20;
            }

            BookingService.getCustomerName().then(function (companyName) {
                vm.companyName = companyName;
            });

            function getInfoForStep1() {
                if (vm.uuid === 'tt') {
                    //ToDo Safety
                    vm.index = 6;
                } else {
                    if (!_.isEmpty($stateParams.club)) {
                        vm.withoutClubsMenuItem = true;
                        $location.hash('surveys');
                        vm.index = 2;
                        vm.locationClub = false;
                        vm.locationCycles = false;
                        vm.locationAdditions = false;
                        vm.locationExtraAdditions = false;
                        vm.locationMembershipBuy = false;
                        vm.locationSurveys = true;
                    } else {
                        vm.beginClub = 0;
                        vm.withoutClubsMenuItem = false;
                        vm.index = 1;
                        vm.selectedMandant = vm.clubsmandants[0];
                        vm.showMoverClubs = vm.clubsmandants.length > vm.limitLengthClubs;

                    }
                }
                vm.locationMembershipBuy = false;
                vm.hasZusatzleistungen = true;
                vm.hasZusatztarife = true;
                vm.isSelectedSurvey = false;
                vm.openedMenuBar = false;
            }

            function loadOnlineSalesFarbenConfiguration() {
                BookingService.getOnlineSalesLayout().then(function (data) {
                    vm.onlineSalesConfig = data;
                    _.toString(vm.onlineSalesConfig.LandingPage);
                    getBackgrounds();
                    if (data.Background === 0) {
                        vm.checkClubImageDefault = true;
                        vm.checkClubImageCustomize = false;
                    } else {
                        vm.checkClubImageDefault = false;
                        vm.checkClubImageCustomize = true;
                    }
                    if (data.Studio_Images === 0) {
                        vm.checkItemBackgroundDefault = true;
                        vm.checkItemBackgroundCustomize = false;
                    } else if (data.Studio_Images === 1) {
                        vm.checkItemBackgroundDefault = false;
                        vm.checkItemBackgroundCustomize = true;
                    }

                    vm.layoutTexte1 = (!_.isNil(data) && !_.isEmpty(data.Text)) ? angular.fromJson(data.Text) :
                        [{
                            "Id": 0,
                            "Name": "step1",
                            "headline": "Online Mitgliedschaft",
                            "subheadline": "Bitte wähle deinen Club",
                            "footer": "Online Sales",
                            "inklusiv": "Inklusivleistungen"
                        }];

                    vm.layoutTexte2 =
                        !_.isNil(data) && !_.isEmpty(data.Text2)
                            ? angular.fromJson(data.Text2)
                            : [
                                {
                                    Id: 0,
                                    Name: "step2",
                                    headline: $translate.instant("T_Herzlich_willkommen_in"),
                                    subheadline: $translate.instant("T_Werde_jetzt_online_Mitglied_und_nutze_viele_Preisvorteile"),
                                },
                            ];

                    vm.layoutTexte3 =
                        !_.isNil(data) && !_.isEmpty(data.Text3)
                            ? angular.fromJson(data.Text3)
                            : [
                                {
                                    Id: 0,
                                    Name: "step3",
                                    subheadline: $translate.instant("T_Bitte_wähle_deine_Zusatztarife"),
                                },
                            ];
                    vm.layoutTexte4 =
                        !_.isNil(data) && !_.isEmpty(data.Text4)
                            ? angular.fromJson(data.Text4)
                            : [
                                {
                                    Id: 0,
                                    Name: "step4",
                                    subheadline: $translate.instant("T_Hier_bieten_wir_dir_weitere_Zusatz_Angebote"),
                                },
                            ];
                    vm.layoutTexte5 =
                        !_.isNil(data) && !_.isEmpty(data.Text5)
                            ? angular.fromJson(data.Text5)
                            : [
                                {
                                    Id: 0,
                                    Name: "step5",
                                    subheadline: $translate.instant("T_Mitgliedschaft_abschließen"),
                                },
                            ];
                    vm.layoutTexte6 =
                        !_.isNil(data) && !_.isEmpty(data.Text6)
                            ? angular.fromJson(data.Text6)
                            : [
                                {
                                    Id: 0,
                                    Name: "step6",
                                    subheadline: $translate.instant("T_Mitgliedschaft_abgeschloßen_Email_geschickt"),
                                },
                            ];

                    vm.layoutColors = (!_.isNil(data) && !_.isEmpty(data.Layout_Colors)) ? angular.fromJson(data.Layout_Colors) :
                        [{
                            "Id": 0,
                            "Name": "header",
                            "items": [{"Id": 0, "Name": "background", "background": ""}, {
                                "Id": 1,
                                "Name": "menuitem",
                                "color": ""
                            }, {"Id": 2, "Name": "clubname", "color": ""}, {
                                "Id": 3,
                                "Name": "activstep",
                                "color": ""
                            }]
                        },
                            {
                                "Id": 1,
                                "Name": "footer",
                                "items": [{"Id": 0, "Name": "background", "background": ""}, {
                                    "Id": 1,
                                    "Name": "text",
                                    "color": ""
                                }]
                            }, {
                            "Id": 2,
                            "Name": "membership",
                            "items": [{"Id": "0", "Name": "background_1", "background": ""}, {
                                "Id": 1,
                                "Name": "text_1",
                                "color": ""
                            }, {"Id": 2, "Name": "background_2", "color": ""}, {
                                "Id": 3,
                                "Name": "text_2",
                                "color": ""
                            }]
                        }, {
                            "Id": 3,
                            "Name": "addition",
                            "items": [{"Id": 0, "Name": "background_1", "background": ""}, {
                                "Id": 1,
                                "Name": "text_1",
                                "color": ""
                            }, {"Id": 2, "Name": "background_2", "color": ""}, {
                                "Id": 3,
                                "Name": "text_2",
                                "color": ""
                            }]
                        }, {
                            "Id": 4,
                            "Name": "shoppingcart",
                            "items": [{"Id": 0, "Name": "icon_color", "color": ""}, {
                                "Id": 1,
                                "Name": "text",
                                "color": ""
                            }, {"Id": 2, "Name": "background_1", "color": ""}, {
                                "Id": 3,
                                "Name": "background_2",
                                "color": ""
                            }]
                        }, {
                            "Id": 5,
                            "Name": "contractdata",
                            "items": [{"Id": 0, "Name": "background_1", "background": ""}, {
                                "Id": 1,
                                "Name": "text_1",
                                "color": ""
                            }, {"Id": 2, "Name": "background_2", "color": ""}, {
                                "Id": 3,
                                "Name": "text_2",
                                "color": ""
                            }]
                        }];
                    if (vm.layoutSettings && vm.layoutSettings.length > 7)
                        vm.selectedFont = vm.layoutSettings[7]["font-family"];
                })

            }

            function loadLayoutConfiguration() {
                BookingService.loadLayoutConfiguration().then(function (data) {
                    vm.layoutSettings = (!_.isNil(data) && !_.isEmpty(data.Layout)) ? angular.fromJson(data.Layout) : [
                        {"Id": 1, "Name": "T_Steps_Header", "background": "", "color": ""},
                        {"Id": 2, "Name": "T_Footer", "background": "", "color": ""},
                        {"Id": 3, "Name": "T_Categories", "background": "", "color": ""},
                        {"Id": 4, "Name": "T_Step3_Buttons", "background": "", "color": ""},
                        {"Id": 5, "Name": "Links", "color": ""},
                        {"Id": 6, "Name": "T_Header_Active", "color": ""},
                        {"Id": 7, "Name": "T_Category_Active", "background": "", "color": ""},
                        {"Id": 8, "Name": "T_Schriftart", "font-family": ""}];
                    if (vm.layoutSettings && vm.layoutSettings.length > 7)
                        vm.selectedFont = vm.layoutSettings[7]["font-family"];
                })

            }

            function getBackgrounds() {
                BookingService.getBackgrounds().then(function (data) {
                    vm.backgrounds = data;
                });
            }

            function getMandantsImages() {
                BookingService.getMandantsImages().then(function (data) {
                    vm.imagesClubs = data;
                    _.forEach(vm.allClubs, function (m) {
                        m.Image = _.find(vm.imagesClubs, {'Mandant_Nr': m.MandantNr});
                    });
                })
            }

            function parseCycles(value, unit) {
                // if (!value || !unit)
                //     return "";

                if (value === 0)
                    return $translate.instant("T_einmalig");

                return ((value > 1) ? value + "-" : "") + $translate.instant(cycleUnits[unit][2]);
            }


            vm.openMenuBar = function () {
                if (vm.openedMenuBar === false) {
                    vm.openedMenuBar = true;
                } else {
                    vm.openedMenuBar = false;
                }
            };

            vm.goToClubs = function (step, memberSelected, member, choosenMemberAngebot, selectedFoundAngebot, startNew, angebotDirekt, choosenClubIndex, selectedMandantNr, selectedPauschalenWithMembershipZyklus,
            selectedPauschalenWithMembershipZyklusIds) {
                if (choosenMemberAngebot || selectedFoundAngebot) {
                    return
                } else {
                    $('html, body').animate({
                        scrollTop: 0
                    }, 'fast');
                    $location.hash(step);
                    vm.locationMembershipBuy = false;
                    vm.index = 1;
                    vm.openedMenuBar = false;
                    vm.idNotFound = false;
                    vm.OSMInactiv = false;
                    vm.isInFuture = false;
                    vm.isInPast = false;
                    vm.noMatched = false;
                    vm.memberSelected = memberSelected;
                    vm.selectedMember = member;
                    vm.chooseAngebotStart = startNew;
                    vm.angebotDirekt = angebotDirekt;
                    vm.choosenClubIndex = choosenClubIndex;
                    vm.selectedMandantNr = selectedMandantNr;
                    vm.selectedPauschalenWithMembershipZyklus = selectedPauschalenWithMembershipZyklus;
                    vm.selectedPauschalenWithMembershipZyklusIds = selectedPauschalenWithMembershipZyklusIds;
                }

            };

            vm.goToActions = function (step) {
                $('html, body').animate({
                    scrollTop: 0
                }, 'fast');
                $location.hash(step);
                vm.locationMembershipBuy = false;
                vm.selectedMember = {};
                vm.openedMenuBar = false;
                vm.choosenClub = false;
                vm.idNotFound = false;
                vm.OSMInactiv = false;
                vm.isInFuture = false;
                vm.isInPast = false;
                vm.noMatched = false;
                vm.choosenMember = false;
                vm.choosePersonSuchen = false;
                vm.chooseAngebotSuchen = false;
                vm.chooseAngebotStart = false;
                vm.index = 6;
                vm.angebotId = '';
                vm.angebotSuchen = false;
                vm.angebotSuchenChoosen = false;
                vm.personSuchen = false;
                vm.angebotDirekt = false;
                vm.member = {};
                vm.foundMember = false;
                vm.members = []
                vm.isSelectedSurvey = false;
                vm.choosenMembershipIndex = false;
                vm.choosenMemberAngebot = false;
                vm.selectedFoundAngebot = false;
                vm.choosenMemberAngebot = false;
                vm.choosenMemberAngebotDatum = false;
                vm.selectedFoundAngebotDatum = false;
                vm.selectedSurvey = null;
                vm.surveySelected = null;
                vm.selectedMembership = null;
                vm.selectedMembershipAdds = null;
            };

            vm.goToSurveys = function (step, memberSelected, selectedMember, choosenNewangebotForMember) {
                if (vm.angebot) {
                    return
                } else {
                    $('html, body').animate({
                        scrollTop: 0
                    }, 'fast');
                    if (vm.selectedMembership || memberSelected) {
                        $location.hash(step);
                        vm.locationMembershipBuy = false;
                        vm.index = 2;
                    }
                    vm.openedMenuBar = false;
                    vm.pflichtZusatztarife = [];
                    vm.selectedAdditions = [];
                    vm.selectedAdditionsGebuehren = [];
                    vm.selectedAdditionsPauschalen = [];
                    vm.memberSelected = memberSelected;
                    vm.selectedMember = selectedMember;
                    if (vm.selectedMember) {
                        vm.selectedMandantNr = selectedMember.MandantId;
                    } else {
                        vm.selectedMandantNr = vm.selectedClub.MandantNr
                    }

                    vm.choosenNewangebotForMember = choosenNewangebotForMember;
                }

            };


            vm.goToSurveysAngebot = function (step, memberSelected, selectedMember, choosenNewangebotForMember, angebot, selectedMembershipAdds, choosenMembershipIndex,
                                              selectedAdditions, selectedPauschalen, selectedGebuehren, additionsGesamt, pflichtZusatztarifePreis,
                                              additionsIds, gebuehrenIds, pauschalenIds, selectedPauschalenWithMembershipZyklus, selectedPauschalenWithMembershipZyklusIds) {
                $('html, body').animate({
                    scrollTop: 0
                }, 'fast');
                $location.hash(step);
                vm.locationMembershipBuy = false;
                vm.index = 2;
                vm.openedMenuBar = false;
                // vm.pflichtZusatztarife = [];
                if (gebuehrenIds) {
                    vm.selectedAdditionsGebuehrenIds = gebuehrenIds;
                }
                if (pauschalenIds) {
                    vm.selectedAdditionsPauschalenIds = pauschalenIds;
                }
                if (additionsIds) {
                    vm.selectedAdditionsIds = additionsIds;
                }
                vm.selectedPauschalenWithMembershipZyklus = selectedPauschalenWithMembershipZyklus;
                vm.selectedPauschalenWithMembershipZyklusIds = selectedPauschalenWithMembershipZyklusIds;
                vm.selectedAdditionsGebuehren = selectedGebuehren ? selectedGebuehren : [];
                vm.selectedAdditionsPauschalen = selectedPauschalen ? selectedPauschalen : [];
                vm.selectedAdditions = selectedAdditions ? selectedAdditions : [];
                vm.additionsGesamt = additionsGesamt;
                vm.selectedAdditionsGesamt = additionsGesamt;
                vm.pflichtZusatztarifePreis = pflichtZusatztarifePreis;
                vm.memberSelected = memberSelected;
                vm.selectedMember = selectedMember;
                vm.selectedMandantNr = selectedMember.MandantId;
                vm.selectedMembership = angebot;
                vm.choosenNewangebotForMember = choosenNewangebotForMember;
                vm.choosenMembershipIndex = choosenMembershipIndex;
                if (choosenMembershipIndex) {
                    vm.isSelectedSurvey = true;
                    vm.selectedSurvey = angebot;
                }
                if (selectedMembershipAdds && selectedMembershipAdds !== false && selectedMembershipAdds.length !== 0) {
                    vm.selectedMembershipAdds = selectedMembershipAdds;
                }


                _.forEach(angebot.Prices.Gebuehrenpreise, function (v, k) {
                    let f = (_.find(vm.selectedMembershipAdds.Gebuehren, {'Id': k}));
                    if (f) {
                        if (v > 0 && f.Option !== 3) {
                            vm.hasGebuehrenWithPrice = true;
                            vm.selectedMembershipGebuehrenToSelect[k] = f;
                            vm.selectedMembershipGebuehrenToSelect[k].price = v;
                            vm.selectedMembershipGebuehrenToSelect[k].zahlzyklus = "einmalig";
                            //ToDo
                            vm.selectedMembershipGebuehrenToSelect[k].zahlzyklusName = vm.selectedMembershipAdds.Gebuehren[k].zahlzyklus;
                        } else if (v > 0 && f.Option === 3) {
                            vm.pflichtGebuehrenOrig.push({Bezeichnung: f.Bezeichnung, price: v, zahlzyklus: 'einmalig'});
                        }
                    }
                });
                vm.pauschalenZyklen = {};

                _.forEach(angebot.Prices.Pauschalenpreise, function (v, k) {
                    let f = (_.find(vm.selectedMembershipAdds.Pauschalen, {'Id': k}));
                    if (f) {
                        vm.pauschalenZyklen[k] = parseCycles(f.Zyklus, f.Zykluseinheit);

                        if (v > 0 && f.Option === 3) {
                            vm.pflichtGebuehrenOrig.push({
                                Bezeichnung: f.Bezeichnung,
                                price: v,
                                zahlzyklus: vm.selectedMembershipAdds.Pauschalen[k].Zahlzyklus
                            });

                        } else if (f.Option !== 3 && v > 0) {
                            vm.selectedMembershipPauschalenToSelect[k] = f;
                            vm.selectedMembershipPauschalenToSelect[k].price = v;
                            vm.selectedMembershipPauschalenToSelect[k].zahlzyklus = vm.selectedMembershipAdds.Pauschalen[k].Zahlzyklus;
                            vm.selectedMembershipPauschalenToSelect[k].zahlzyklusName = vm.selectedMembershipAdds.Pauschalen[k].Zahlzyklus;
                            vm.hasPauschalenWithPrice = true;
                        }
                    }
                });
            };

            vm.goToAdditions = function (step) {
                if (vm.index === 7 || vm.index === 8 || vm.angebot) {
                    return
                }
                $('html, body').animate({
                    scrollTop: 0
                }, 'fast');
                if (vm.selectedMembership && (vm.hasZusatztarife === true && (vm.hasZusatztarifeWithPrice || vm.zusatztarifenWithPrice['true']))) {
                    $location.hash(step);
                    vm.locationMembershipBuy = false;
                    vm.index = 3
                }
                vm.openedMenuBar = false;
            };

            vm.goToAdditionsAngebot = function (step, memberSelected, selectedMember, hasZusatztarife, hasZusatztarifeWithPrice, choosenMemberAngebot,
                                                selectedFoundAngebot, selectedAdditions, selectedAdditionsGesamt, selectedMembership, additionsGesamt,
                                                pflichtZusatztarifePreis, additionsIds, gebuehrenIds, pauschalenIds, selectedPauschalenWithMembershipZyklus, selectedPauschalenWithMembershipZyklusIds) {
                if (vm.index === 7 || vm.index === 8) {
                    return
                }
                $('html, body').animate({
                    scrollTop: 0
                }, 'fast');
                $location.hash(step);
                vm.locationMembershipBuy = false;
                vm.index = 3;
                vm.selectedMember = selectedMember;
                vm.memberSelected = memberSelected;
                if (vm.selectedMember) {
                    vm.selectedMandantNr = selectedMember.MandantId;
                }
                if (gebuehrenIds) {
                    vm.selectedAdditionsGebuehrenIds = gebuehrenIds;
                }
                if (pauschalenIds) {
                    vm.selectedAdditionsPauschalenIds = pauschalenIds;
                }
                if (additionsIds) {
                    vm.selectedAdditionsIds = additionsIds;
                }
                vm.selectedPauschalenWithMembershipZyklus = selectedPauschalenWithMembershipZyklus;
                vm.selectedPauschalenWithMembershipZyklusIds =selectedPauschalenWithMembershipZyklusIds;
                vm.openedMenuBar = false;
                vm.choosenMemberAngebot = choosenMemberAngebot;
                vm.selectedFoundAngebot = selectedFoundAngebot;
                vm.selectedMembershipZTToSelect = {};
                vm.hasZusatztarife = hasZusatztarife;
                vm.HasZusatztarifeWithPrice = hasZusatztarifeWithPrice;
                vm.selectedAdditions = selectedAdditions;
                vm.selectedAdditionsGesamt = selectedAdditionsGesamt;
                vm.selectedMembership = selectedMembership;
                vm.additionsGesamt = additionsGesamt;
                vm.pflichtZusatztarifePreis = pflichtZusatztarifePreis;
            };

            vm.goToExtraAdditions = function (step) {
                if (vm.angebot) {
                    return
                } else {
                    $('html, body').animate({
                        scrollTop: 0
                    }, 'fast');
                    if (vm.selectedMembership && (vm.hasZusatzleistungen === true && (vm.hasPauschalenWithPrice === true || vm.hasGebuehrenWithPrice === true))) {
                        $location.hash(step);
                        vm.locationMembershipBuy = false;
                        vm.index = 4;
                    }
                    vm.openedMenuBar = false;
                }

            };

            vm.goToExtraAdditionsAngebot = function (step, memberSelected, selectedmember, hasZusatzleistungen, hasPauschalenwithPrice,
                                                     hasGebuehrenWithPrice, selectedMember, angebot, choosenMemberAngebot, selectedFoundAngebot,
                                                     choosenNewangebotForMember, pflichtZusatztarife, selectedAdditions, selectedAdditionsGesamt,
                                                     pflichtZusatztarifePreis, selectedMembershipAdds, additionsIds, gebuehrenIds, pauschalenIds, selectedPauschalenWithMembershipZyklus, selectedPauschalenWithMembershipZyklusIds) {
                if (vm.index === 7 || vm.index === 8) {
                    return
                }
                $('html, body').animate({
                    scrollTop: 0
                }, 'fast');
                $location.hash(step);
                if (selectedMembershipAdds && selectedMembershipAdds !== false && selectedMembershipAdds.length !== 0) {
                    vm.selectedMembershipAdds = selectedMembershipAdds;
                }
                if (gebuehrenIds) {
                    vm.selectedAdditionsGebuehrenIds = gebuehrenIds;
                }
                if (pauschalenIds) {
                    vm.selectedAdditionsPauschalenIds = pauschalenIds;
                }
                if (additionsIds) {
                    vm.selectedAdditionsIds = additionsIds;
                }
                vm.selectedPauschalenWithMembershipZyklus = selectedPauschalenWithMembershipZyklus;
                vm.selectedPauschalenWithMembershipZyklusIds = selectedPauschalenWithMembershipZyklusIds;
                vm.choosenNewangebotForMember = choosenNewangebotForMember;
                vm.selectedMember = selectedMember;
                vm.selectedAngebot = angebot;
                vm.selectedMembership = angebot;
                if (choosenMemberAngebot || selectedFoundAngebot) {
                    vm.memberSelected = true;
                    vm.selectedMandantNr = selectedMember.MandantId;
                }
                vm.memberSelected = memberSelected;
                vm.selectedMember = selectedMember;
                vm.hasZusatzleistungen = hasZusatzleistungen;
                vm.hasPauschalenWithPrice = hasPauschalenwithPrice;
                vm.hasGebuehrenWithPrice = hasGebuehrenWithPrice;
                vm.locationMembershipBuy = false;
                vm.index = 4;
                vm.openedMenuBar = false;
                vm.choosenMemberAngebot = choosenMemberAngebot;
                vm.selectedFoundAngebotDatum = selectedFoundAngebot;
                vm.selectedMembershipGebuehrenToSelect = {};
                vm.selectedMembershipPauschalenToSelect = {};
                vm.selectedMembershipZTToSelect = {};

                    _.forEach(angebot.Prices.Zusatztarifpreise, function (v, k) {
                        let f = (_.find(vm.selectedMembershipAdds.Zusatztarife, {'Id': k}));
                        if (f) {
                            if (v > 0 && f.Option === 3) {
                                vm.pflichtZusatztarifePreis = vm.pflichtZusatztarifePreis + v;
                                if (!vm.pflichtZusatztarife) {
                                    vm.pflichtZusatztarife = [];
                                }
                                vm.pflichtZusatztarife.push({
                                    Bezeichnung: f.Bezeichnung,
                                    price: v,
                                    zahlzyklus: vm.selectedMembershipAdds.Zusatztarife[k].Zahlzyklus
                                });
                            }
                            else if (f.Option !== 3 && v > 0) {
                                vm.selectedMembershipZTToSelect[k] = f;
                            }
                        }
                    });

                _.forEach(angebot.Prices.Gebuehrenpreise, function (v, k) {
                    let f = (_.find(vm.selectedMembershipAdds.Gebuehren, {'Id': k}));
                    if (f) {
                        if (v > 0 && f.Option !== 3) {
                            vm.hasGebuehrenWithPrice = true;
                            vm.selectedMembershipGebuehrenToSelect[k] = f;
                            vm.selectedMembershipGebuehrenToSelect[k].price = v;
                            vm.selectedMembershipGebuehrenToSelect[k].zahlzyklus = "einmalig";
                            //ToDo
                            vm.selectedMembershipGebuehrenToSelect[k].zahlzyklusName = vm.selectedMembershipAdds.Gebuehren[k].zahlzyklus;
                        } else if (v > 0 && f.Option === 3) {
                            vm.pflichtGebuehrenOrig.push({Bezeichnung: f.Bezeichnung, price: v, zahlzyklus: 'einmalig'});
                        }
                    }
                });
                vm.pauschalenZyklen = {};

                _.forEach(angebot.Prices.Pauschalenpreise, function (v, k) {
                    let f = (_.find(vm.selectedMembershipAdds.Pauschalen, {'Id': k}));
                    if (f) {
                        vm.pauschalenZyklen[k] = parseCycles(f.Zyklus, f.Zykluseinheit);

                        if (v > 0 && f.Option === 3) {
                            vm.pflichtGebuehrenOrig.push({
                                Bezeichnung: f.Bezeichnung,
                                price: v,
                                zahlzyklus: vm.selectedMembershipAdds.Pauschalen[k].Zahlzyklus
                            });

                        } else if (f.Option !== 3 && v > 0) {
                            vm.selectedMembershipPauschalenToSelect[k] = f;
                            vm.selectedMembershipPauschalenToSelect[k].price = v;
                            vm.selectedMembershipPauschalenToSelect[k].zahlzyklus = vm.selectedMembershipAdds.Pauschalen[k].Zahlzyklus;
                            vm.selectedMembershipPauschalenToSelect[k].zahlzyklusName = vm.selectedMembershipAdds.Pauschalen[k].Zahlzyklus;
                            vm.hasPauschalenWithPrice = true;
                        }
                    }
                });
                if (!_.isEmpty(angebot.Prices.Zusatztarifpreise) && angebot.Prices.Zusatztarifpreise) {
                    vm.hasZusatztarife = true;
                    vm.zusatztarifenWithPrice = (_.countBy(angebot.Prices.Zusatztarifpreise, function (p) {
                        return p > 0;
                    }));
                }
                vm.pflichtZusatztarife = pflichtZusatztarife;
                vm.selectedAdditions = selectedAdditions;
                vm.selectedAdditionsGesamt = selectedAdditionsGesamt;
                vm.pflichtZusatztarifePreis = pflichtZusatztarifePreis;
                vm.additionsGesamt = selectedAdditions;
            };

            vm.goToBuyMembership = function (step) {
                if (vm.angebot) {
                    return
                } else {
                    $('html, body').animate({
                        scrollTop: 0
                    }, 'fast');
                    if (vm.selectedMembership) {
                        $location.hash(step);
                        vm.locationMembershipBuy = true;
                        vm.index = 5;
                    }
                    vm.openedMenuBar = false;
                }

            };

            vm.selectClub = function (i, index, step) {
                vm.selectedMandant = i;
                vm.selectedMandantNr = i.MandantNr;
                $('html, body').animate({
                    scrollTop: 0
                }, 'fast');
                vm.locationMembershipBuy = false;
                $location.hash(step);
                vm.notStep1 = true;
                vm.begin = 0;
                vm.index = 2;

                if (vm.uuid !== 'false' && vm.uuid !== 'tt') {
                    BookingService.loadMembershipsOnlineSalesLinkConfig(vm.selectedMandantNr, vm.uuid).then(function (data) {
                        if (data.length === 0 || !data || _.isUndefined(data)) {
                            vm.noMatched = true;
                        } else {
                            if (data.LinkIdNotFound === true) {
                                vm.idNotFound = true;
                            } else if (data.IsInactiv === true) {
                                vm.OSMInactiv = true;
                                vm.isInFuture = data.IsInFuture;
                                vm.isInPast = data.IsInPast;
                                if (data.IsInFuture === true) {
                                    vm.futureDate = data.FutureDate;
                                }
                            }
                        }
                    }).catch(function () {
                        vm.noMatched = true;
                        vm.membershipsOptions = []; // TODO: evtl. Fehleranzeige
                    })
                } else {
                    BookingService.loadMembershipsOnlineSales(vm.selectedMandantNr).then(function (data) {
                        vm.membershipsOptions = data;
                    }).catch(function () {
                        vm.membershipsOptions = []; // TODO: evtl. Fehleranzeige
                    })
                }
            };

            vm.selectSurvey = function (survey, surveyAdds, surveyId, memberships, selectedMembershipAdds, choosenNewangebotForMember, member, memberSelected, choosenMembershipIndex,
                                        selectedAdditions, selectedAdditionsPauschalen, selectedAdditionsGebuehren, selectedAdditionsGesamt, pflichtZusatztarifePreis) {
                $('html, body').animate({
                    scrollTop: 0
                }, 'fast');
                vm.choosenNewangebotForMember = choosenNewangebotForMember;
                vm.memberSelected = memberSelected;
                if (memberSelected) {
                    vm.selectedMember = member;
                }
                vm.choosenMembershipIndex = choosenMembershipIndex;
                vm.memberships = memberships;
                vm.selectedMembership = survey;
                vm.selectedAdditionsGebuehren = selectedAdditionsGebuehren ? selectedAdditionsGebuehren : [];
                vm.selectedAdditionsPauschalen = selectedAdditionsPauschalen ? selectedAdditionsPauschalen : [];
                vm.selectedAdditions = selectedAdditions ? selectedAdditions : [];
                vm.isSelectedSurvey = true;
                vm.selectedMembershipAdds = selectedMembershipAdds? selectedMembershipAdds : surveyAdds;
                vm.locationMembershipBuy = false;
                vm.surveyId = surveyId;
                vm.selectedAdditionsGesamt = selectedAdditionsGesamt;
                vm.pflichtZusatztarifePreis = pflichtZusatztarifePreis;
                vm.minZusatzleistungen = survey ? (survey.MinZusatzleistungen || 0) : 0;
                vm.basistarif = [{
                    Bezeichnung: 'Basistarif',
                    price: vm.selectedMembership.Preis,
                    zahlzyklus: vm.selectedMembership.ZahlzyklusName
                }];
                vm.pflichtGebuehren = [];
                vm.pflichtGebuehrenOrig = [];
                vm.selectedMembershipZTToSelect = {};
                vm.selectedMembershipGebuehrenToSelect = {};
                vm.selectedMembershipPauschalenToSelect = {};
                vm.hasZusatztarife = false;
                vm.zusatztarifenWithPrice = null;
                vm.hasGebuehrenWithPrice = null;
                vm.hasPauschalenWithPrice = null;
                // if (!_.isEmpty(survey.Prices.Zusatztarifpreise) && survey.Prices.Zusatztarifpreise) {
                //     vm.hasZusatztarife = true;
                //     vm.zusatztarifenWithPrice = (_.countBy(survey.Prices.Zusatztarifpreise, function (p) {
                //         return p > 0;
                //     }));
                // }

                if(vm.selectedMembershipAdds || !vm.angebot) {
                    _.forEach(survey.Prices.Zusatztarifpreise, function (v, k) {
                        vm.hasZusatztarife = true
                        let f = (_.find(vm.selectedMembershipAdds.Zusatztarife, {'Id': k}));
                        if (f) {
                            if (v > 0 && f.Option === 3) {
                                vm.pflichtZusatztarifePreis = vm.pflichtZusatztarifePreis + v;
                                if (!vm.pflichtZusatztarife) {
                                    vm.pflichtZusatztarife = [];
                                }
                                vm.pflichtZusatztarife.push({
                                    Bezeichnung: f.Bezeichnung,
                                    price: v,
                                    zahlzyklus: vm.selectedMembershipAdds.Zusatztarife[k].Zahlzyklus
                                });
                            }
                            else if (f.Option !== 3 && v > 0) {
                                vm.zusatztarifenWithPrice = (_.countBy(survey.Prices.Zusatztarifpreise, function (p) {
                                             return p > 0;
                                         }));
                                vm.selectedMembershipZTToSelect[k] = f;
                            }
                        }
                    });
                _.forEach(survey.Prices.Gebuehrenpreise, function (v, k) {
                    let f = (_.find(vm.selectedMembershipAdds.Gebuehren, {'Id': k}));
                    if (f) {
                        if (v > 0 && f.Option !== 3) {
                            vm.hasGebuehrenWithPrice = true;
                            vm.selectedMembershipGebuehrenToSelect[k] = f;
                            vm.selectedMembershipGebuehrenToSelect[k].price = v;
                            vm.selectedMembershipGebuehrenToSelect[k].zahlzyklus = "einmalig";
                            vm.selectedMembershipGebuehrenToSelect[k].zahlzyklusName = vm.selectedMembershipAdds.Gebuehren[k].Zahlzyklus;
                        } else if (v > 0 && f.Option === 3) {
                            vm.pflichtGebuehrenOrig.push({Bezeichnung: f.Bezeichnung, price: v, zahlzyklus: 'einmalig'});
                        }
                    }
                });
                vm.pauschalenZyklen = {};

                _.forEach(survey.Prices.Pauschalenpreise, function (v, k) {
                    let f = (_.find(vm.selectedMembershipAdds.Pauschalen, {'Id': k}));
                    if (f) {
                        vm.pauschalenZyklen[k] = parseCycles(f.Zyklus, f.Zykluseinheit);

                        if (v > 0 && f.Option === 3) {
                            vm.pflichtGebuehrenOrig.push({
                                Bezeichnung: f.Bezeichnung,
                                price: v,
                                zahlzyklus: vm.selectedMembershipAdds.Pauschalen[k].Zahlzyklus
                            });

                        } else if (f.Option !== 3 && v > 0) {
                            vm.selectedMembershipPauschalenToSelect[k] = f;
                            vm.selectedMembershipPauschalenToSelect[k].price = v;
                            vm.selectedMembershipPauschalenToSelect[k].zahlzyklus = vm.selectedMembershipAdds.Pauschalen[k].Zahlzyklus;
                            vm.selectedMembershipPauschalenToSelect[k].zahlzyklusName = vm.selectedMembershipAdds.Pauschalen[k].Zahlzyklus;
                            vm.hasPauschalenWithPrice = true;
                        }
                    }
                });
                }
                if (vm.hasZusatztarife && !_.isEmpty(vm.zusatztarifenWithPrice)) {
                    if (vm.zusatztarifenWithPrice['true']) {
                        vm.index = 3;
                    }
                }
                if (!vm.hasZusatztarife || ((_.isEmpty(vm.zusatztarifenWithPrice) || !vm.zusatztarifenWithPrice['true']) && (vm.hasGebuehrenWithPrice || vm.hasPauschalenWithPrice))) {
                    vm.index = 4;
                }
                if (((vm.hasZusatztarife && (vm.zusatztarifenWithPrice === null || !vm.zusatztarifenWithPrice['true']) && (!vm.hasGebuehrenWithPrice && !vm.hasPauschalenWithPrice)) || (!vm.hasZusatztarife && !vm.hasPauschalenWithPrice && !vm.hasGebuehrenWithPrice))) {
                    vm.index = 5;
                }
                if(vm.selectedAdditions.length === 0) {
                    vm.selectedAdditionsIds = [];
                }
                if(vm.selectedAdditionsGebuehren.length === 0) {
                    vm.selectedAdditionsGebuehrenIds = [];
                }
                if(vm.selectedAdditionsPauschalen.length === 0) {
                    vm.selectedAdditionsPauschalenIds = [];
                }

            };

            vm.selectExtraAdditions = function (survey, surveyId, pauschalen, pflichtZusatztarife, gebuehren, basisTarif, pflichtGebuehrenOrig, pflichtGebuehren, selectedAdditions, selectedAdditionsGesamt, selectedMembershipGebuehrenToSelect, selectedMembershipPauschalenToSelect) {
                $('html, body').animate({
                    scrollTop: 0
                }, 'fast');
                if (pauschalen || gebuehren) {
                    vm.index = 4;
                } else {
                    vm.index = 5
                }

                vm.hasPauschalenWithPrice = pauschalen;
                vm.hasGebuehrenWithPrice = gebuehren;
                vm.selectedMembership = survey;
                vm.surveyId = surveyId;
                vm.basistarif = basisTarif;
                vm.pflichtGebuehren = pflichtGebuehren;
                vm.pflichtGebuehrenOrig = pflichtGebuehrenOrig;
                vm.pflichtZusatztarife = pflichtZusatztarife;
                vm.selectedMembershipGebuehrenToSelect = selectedMembershipGebuehrenToSelect;
                vm.selectedMembershipPauschalenToSelect = selectedMembershipPauschalenToSelect;
                vm.selectedAdditionsGesamt = selectedAdditionsGesamt;
                vm.selectedAdditions = selectedAdditions;

            };

            vm.buyMembership = function (survey, surveyId, basistarif, pflichtgebuehren, selectedAdditions, selectedPauschalen, selectedGebuehren, selectedAdditionsGesamt,
                                         selectedFoundAngebot, choosenMemberAngebot, angebot, chooseMemberAngebotDaum, selectedFoundAngebotDatum, choosenNewangebotForMember,
                                         pflichtZusatztarife, pflichtZusatztarifePreis, additionsSelected, pflichtGebuehren, pauschalenSelected,
                                         gebuehrenSelected, additionsIds, gebuehrenIds, pauschalenIds, selectedPauschalenWithMembershipZyklus, selectedPauschalenWithMembershipZyklusIds) {

                $('html, body').animate({
                    scrollTop: 0
                }, 'fast');
                vm.index = 5;
                vm.vertragSaved = false;
                vm.istVertrag = false;
                vm.istAngebot = false;
                vm.savedAngebotId = null;
                vm.pdf = null;
                vm.foundAngebot = survey;
                vm.choosenNewangebotForMember = choosenNewangebotForMember;
                vm.selectedMembership = survey;
                vm.selectedMembershipId = surveyId;
                vm.basistarif = basistarif;
                vm.pflichtZusatztarife = pflichtZusatztarife;
                vm.pflichtZusatztarifePreis = pflichtZusatztarifePreis;
                vm.selectedAdditions = additionsSelected;
                vm.pflichtGebuehren = pflichtGebuehren;
                vm.selectedPauschalen = selectedPauschalen;
                vm.selectedGebuehren = pflichtGebuehren;
                vm.selectedAdditionsGebuehren = gebuehrenSelected;
                vm.selectedAdditionsPauschalen = pauschalenSelected;
                vm.selectedAdditionsGesamt = selectedAdditionsGesamt;
                vm.selectedFoundAngebot = selectedFoundAngebot;
                vm.choosenMemberAngebot = choosenMemberAngebot;
                vm.choosenMemberAngebotDatum = chooseMemberAngebotDaum;
                vm.selectedFoundAngebotDatum = selectedFoundAngebotDatum;
                if (vm.selectedFoundAngebot || vm.choosenMemberAngebot) {
                    vm.selectedAngebot = angebot;
                    vm.choosenNewangebotForMember = false;
                }
                if (survey.PflichtgebuehrenOrig) {
                    vm.pflichtGebuehrenOrig = survey.PflichtgebuehrenOrig;
                    vm.selectedMembershipAdds = survey;
                }
                if (survey.Member) {
                    vm.selectedMember = survey.Member;
                    vm.selectedMandantNr = survey.Member.MandantId;
                    vm.selectedMandant = _.find(vm.clubsmandants, {'MandantNr': vm.selectedMandantNr})
                }
                if (survey.HasPauschalenwithPrice) {
                    vm.hasZusatzleistungen = true;
                    vm.hasPauschalenWithPrice = survey.HasPauschalenwithPrice;
                }
                if (survey.HasGebuehrenWithPrice) {
                    vm.hasZusatzleistungen = true;
                    vm.hasGebuehrenWithPrice = survey.HasGebuehrenWithPrice;
                }
                if (survey.HasZusatztarifeWithPrice) {
                    vm.hasZusatztarife = true;
                    vm.hasZusatztarifeWithPrice = survey.HasZusatztarifeWithPrice;
                }
                if (gebuehrenIds) {
                    vm.selectedAdditionsGebuehrenIds = gebuehrenIds;
                }
                if (pauschalenIds) {
                    vm.selectedAdditionsPauschalenIds = pauschalenIds;
                }
                if (additionsIds) {
                    vm.selectedAdditionsIds = additionsIds;
                }
                if (survey.AngebotSelectedAdditionsIds && _.isUndefined(additionsIds)) {
                    vm.selectedAdditionsIds = survey.AngebotSelectedAdditionsIds;
                }
                if (survey.AngebotSelectedAdditionsPauschalenIds && _.isUndefined(pauschalenIds)) {
                    vm.selectedAdditionsPauschalenIds = survey.AngebotSelectedAdditionsPauschalenIds;
                }
                if (survey.AngebotSelectedAdditionsGebuehrenIds && _.isUndefined(gebuehrenIds)) {
                    vm.selectedAdditionsGebuehrenIds = survey.AngebotSelectedAdditionsGebuehrenIds;
                }
                if (survey.AngebotSelectedAdditions && _.isUndefined(additionsIds)) {
                    vm.selectedAdditions = survey.AngebotSelectedAdditions;
                } else  {
                    vm.selectedAdditions = additionsSelected;
                }
                if (survey.AngebotSelectedAdditionsGebuehren && _.isUndefined(gebuehrenIds)) {
                    vm.selectedAdditionsGebuehren = survey.AngebotSelectedAdditionsGebuehren;
                } else  {
                    vm.selectedAdditionsGebuehren = gebuehrenSelected;
                }
                if (survey.AngebotSelectedAdditionsPauschalen && _.isUndefined(pauschalenIds)) {
                    vm.selectedAdditionsPauschalen = survey.AngebotSelectedAdditionsPauschalen;
                } else {
                    vm.selectedAdditionsPauschalen = pauschalenSelected;
                }
                if(survey.AngebotSelectedPauschalenWithMembershipZyklus && survey.AngebotSelectedPauschalenWithMembershipZyklus .length > 0 && _.isUndefined(selectedPauschalenWithMembershipZyklusIds)) {
                    vm.selectedPauschalenWithMembershipZyklus = survey.AngebotSelectedPauschalenWithMembershipZyklus;

                  //  vm.selectedAdditionsPauschalen = _.differenceBy(vm.selectedPauschalenWithMembershipZyklus, vm.selectedAdditionsPauschalen, 'Id')
                    vm.selectedAdditionsPauschalen = _.differenceBy(vm.selectedAdditionsPauschalen, vm.selectedPauschalenWithMembershipZyklus, 'Id')

                } else {
                    vm.selectedPauschalenWithMembershipZyklus = selectedPauschalenWithMembershipZyklus;
                }
                if(survey.AngebotSelectedPauschalenWithMembershipZyklusIds && survey.AngebotSelectedPauschalenWithMembershipZyklusIds.length > 0 && _.isUndefined(selectedPauschalenWithMembershipZyklusIds)) {
                    vm.selectedPauschalenWithMembershipZyklusIds = survey.AngebotSelectedPauschalenWithMembershipZyklusIds;
                    vm.selectedAdditionsPauschalenIds = _.difference(vm.selectedPauschalenWithMembershipZyklusIds, vm.selectedAdditionsPauschalenIds)
                } else {
                    vm.selectedPauschalenWithMembershipZyklusIds = selectedPauschalenWithMembershipZyklusIds;
                }

            };

            vm.moveLeftClub = function () {
                vm.chunkedClub = _.chunk(vm.clubsmandants, vm.limitLengthClubs);
                vm.lengthChunkedClubs = (vm.chunkedClub).length;
                vm.beginClub--;
                if (vm.beginClub < 0) {
                    vm.beginClub = vm.lengthChunkedClubs;
                }
                vm.allClubs = vm.chunkedClub[vm.beginClub];
            };

            vm.moveRightClub = function () {
                vm.chunkedClub = _.chunk(vm.clubsmandants, vm.limitLengthClubs);
                vm.lengthChunkedClubs = (vm.chunkedClub).length;
                vm.beginClub++;
                if (vm.beginClub === vm.lengthChunkedClubs) {
                    vm.beginClub = 0;
                }
                vm.allClubs = vm.chunkedClub[vm.beginClub];
            };

            vm.angebotStart = function (selectedMember) {
                vm.selectedMember = selectedMember;
                $('html, body').animate({
                    scrollTop: 0
                }, 'fast');
                vm.locationMembershipBuy = false;
                $location.hash('surveys');
                vm.notStep1 = true;
                vm.begin = 0;
                vm.index = 2;

            }

            vm.goToAbschluss = function (isVertrag, isAngebot, member) {
                vm.index = 7;
                vm.isVertrag = isVertrag;
                vm.isAngebot = isAngebot;
                if (member) {
                    vm.selectedMember = member
                }
            }

            vm.chooseClub = function (club, index, step) {
                if (vm.angebot) {
                    vm.selectedClub = club;
                    vm.choosenClubIndex = index;
                    if (vm.choosenClub) {
                        vm.choosenClub = false;
                    } else {
                        vm.choosenClub = true;
                    }
                    vm.choosenMembershipIndex = null;
                    vm.selectedAdditions = null;
                } else {
                    $('html, body').animate({
                        scrollTop: 0
                    }, 'fast');
                    vm.locationMembershipBuy = false;
                    vm.selectedMandant = club;
                    vm.selectedMandantNr = club.MandantNr;
                    $location.hash(step);
                    vm.notStep1 = true;
                    vm.begin = 0;
                    vm.index = 2;
                 //   vm.choosenMembershipIndex = null;

                    if (vm.uuid !== 'false') {
                        BookingService.loadMembershipsOnlineSalesLinkConfig(vm.selectedMandantNr, vm.uuid).then(function (data) {
                            if (data.length === 0 || !data || _.isUndefined(data)) {
                                vm.noMatched = true;
                            } else {
                                if (data.LinkIdNotFound === true) {
                                    vm.idNotFound = true;
                                } else if (data.IsInactiv === true) {
                                    vm.OSMInactiv = true;
                                    vm.isInFuture = data.IsInFuture;
                                    vm.isInPast = data.IsInPast;
                                    if (data.IsInFuture === true) {
                                        vm.futureDate = data.FutureDate;
                                    }
                                }
                            }
                        }).catch(function () {
                            vm.noMatched = true;
                            vm.membershipsOptions = []; // TODO: evtl. Fehleranzeige
                        })
                    } else {
                        BookingService.loadMembershipsOnlineSales(vm.selectedMandantNr).then(function (data) {
                            vm.membershipsOptions = data;
                        }).catch(function () {
                            vm.membershipsOptions = []; // TODO: evtl. Fehleranzeige
                        })
                    }
                }
            }

            vm.goBackActions = function () {
                $('html, body').animate({
                    scrollTop: 0
                }, 'fast');
                vm.locationMembershipBuy = false;
                vm.selectedMember = {};
                vm.openedMenuBar = false;
                vm.choosenClub = false;
                vm.idNotFound = false;
                vm.OSMInactiv = false;
                vm.isInFuture = false;
                vm.isInPast = false;
                vm.noMatched = false;
                vm.choosenMember = false;
                vm.choosePersonSuchen = false;
                vm.chooseAngebotSuchen = false;
                vm.chooseAngebotStart = false;
                vm.index = 6;
                vm.angebotId = '';
                vm.angebotSuchen = false;
                vm.angebotSuchenChoosen = false;
                vm.personSuchen = false;
                vm.angebotDirekt = false;
                vm.member = {};
                vm.foundMember = false;
                vm.members = [];
                vm.isSelectedSurvey = false;
                vm.choosenMembershipIndex = false;
                vm.choosenMemberAngebot = false;
                vm.selectedFoundAngebot = false;
                vm.choosenMemberAngebot = false;
                vm.choosenMemberAngebotDatum = false;
                vm.selectedFoundAngebotDatum = false;
                vm.selectedSurvey = null;
                vm.surveySelected = null;
                vm.selectedMembership = null;
                vm.foundAngebot = null;
                vm.vertragSaved = false;
                vm.istVertrag = false;
                vm.istAngebot = false;
                vm.savedAngebotId = null;
                vm.pdf = null;
                vm.changedMitgliedschaft = false;
                vm.selectedMembershipAdds = null;
            }

            vm.goToAbgeschlossen = function (isAngebot, angebotId, email, pdf) {
                vm.choosenMember = false;
                vm.choosePersonSuchen = false;
                vm.chooseAngebotSuchen = false;
                vm.chooseAngebotStart = false;
                vm.index = 8;
                vm.angebotId = '';
                vm.angebotSuchen = false;
                vm.angebotSuchenChoosen = false;
                vm.personSuchen = false;
                vm.angebotDirekt = false;
                vm.member = {};
                vm.foundMember = false;
                vm.members = []
                vm.isAngebot = isAngebot;
                vm.vertragSaved = !isAngebot;
                vm.istVertrag = !isAngebot;
                vm.istAngebot = isAngebot;
                vm.savedAngebotId = angebotId;
                vm.isEmailAngebotSend = email;
                vm.pdfContract = pdf;
            }

            vm.goToAngebot = function () {
                vm.choosenMember = false;
                vm.choosePersonSuchen = false;
                vm.chooseAngebotSuchen = false;
                vm.chooseAngebotStart = false;
                vm.choosenClub = false;
                vm.index = 6;
                vm.angebotId = '';
                vm.angebotSuchen = false;
                vm.angebotSuchenChoosen = false;
                vm.personSuchen = false;
                vm.angebotDirekt = false;
                vm.member = {};
                vm.foundMember = false;
                vm.members = [];
                vm.choosenClub = false;
                vm.isSelectedSurvey = false;
                vm.choosenMembershipIndex = null;
                vm.foundAngebot = null;
                vm.choosenMemberAngebot = false;
                vm.selectedFoundAngebot = false;
                vm.choosenMemberAngebot = false;
                vm.choosenMemberAngebotDatum = false;
                vm.selectedFoundAngebotDatum = false;
                vm.vertragSaved = false;
                vm.istVertrag = false;
                vm.istAngebot = false;
                vm.savedAngebotId = null;
                vm.pdf = null;
                vm.selectedSurvey = null;
                vm.surveySelected = null;
                vm.selectedMembership = null;
                vm.changedMitgliedschaft = false;
                vm.selectedMember = {};
                vm.selectedMembershipAdds = null;
            };

        }]);
